/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The type of Zoom credential.

- `app`: SDK-only credentials (client_id and client_secret) for joining meetings
- `user`: User-authorized credentials with OAuth tokens for OBF token support
 */
export type CreateZoomCredential201DataCredentialType =
  (typeof CreateZoomCredential201DataCredentialType)[keyof typeof CreateZoomCredential201DataCredentialType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateZoomCredential201DataCredentialType = {
  app: "app",
  user: "user"
} as const
